import { IconSVG } from '../types';

export const ChevronLeft = ({ size, style }: IconSVG) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8 12l3.9 3.9a.948.948 0 01.275.7.948.948 0 01-.275.7.948.948 0 01-.7.275.949.949 0 01-.7-.275l-4.6-4.6a.877.877 0 01-.212-.325A1.107 1.107 0 018.425 12c0-.133.02-.258.063-.375A.877.877 0 018.7 11.3l4.6-4.6a.948.948 0 01.7-.275c.283 0 .517.092.7.275a.948.948 0 01.275.7.948.948 0 01-.275.7L10.8 12z" />
    <path
      fillOpacity="0.2"
      d="M10.8 12l3.9 3.9a.948.948 0 01.275.7.948.948 0 01-.275.7.948.948 0 01-.7.275.949.949 0 01-.7-.275l-4.6-4.6a.877.877 0 01-.212-.325A1.107 1.107 0 018.425 12c0-.133.02-.258.063-.375A.877.877 0 018.7 11.3l4.6-4.6a.948.948 0 01.7-.275c.283 0 .517.092.7.275a.948.948 0 01.275.7.948.948 0 01-.275.7L10.8 12z"
    />
  </svg>
);
